import moment from "moment";
import { Table } from "reactstrap";
import { FiCornerDownRight } from "react-icons/fi";
const LogTable = ({ title = "Order Logs / Notes", orderNotes }) => {

  return (
    <div className="modern-table-container mt-4">
      {orderNotes?.length > 0 ? (
        <div className="settings-card shadow-sm border-0 overflow-hidden" style={{ borderRadius: '12px' }}>
          <div className="bg-primary-soft p-3 border-bottom d-flex align-items-center gap-2">
            <h5 className="mb-0 fw-bold text-dark fs-15">{title}</h5>
            <span className="badge bg-white text-primary rounded-pill px-3 py-1 shadow-sm border">{orderNotes?.length}</span>
          </div>
          <Table
            responsive
            hover
            bordered
            className="modern-table modern-table-sm mb-0"
            style={{ fontSize: '13px' }}
          >
            <thead style={{ backgroundColor: "#fff" }}>
              <tr>
                <th style={{ width: "50px" }} className="text-center align-middle text-muted">#</th>
                <th style={{ width: "320px" }} className="align-middle">Author & Timestamp</th>
                <th className="align-middle">Note Details / System Logs</th>
              </tr>
            </thead>
            <tbody>
              {orderNotes?.map((row, index) => (
                <tr key={index} style={{ background: index % 2 === 0 ? "#fdfdfd" : "white" }}>
                  <td className="text-center align-middle">
                    <FiCornerDownRight size={14} className="text-muted opacity-50" />
                  </td>
                  <td className="align-middle">
                    <div className="d-flex flex-column py-1">
                      <span className="fw-bold text-primary fs-13">
                        {row.createdBy?.username || "System"}
                        <span className="text-muted fw-normal ms-1 fs-11">({row.createdBy?.role || "Auto"})</span>
                      </span>
                      <span className="text-muted fs-11 mt-1">
                        {moment(row.createdAt).format("MMM Do YYYY, h:mm a")}
                      </span>
                    </div>
                  </td>
                  <td className="align-middle">
                    <div
                      className="fs-13 text-dark lh-base py-1"
                      dangerouslySetInnerHTML={{
                        __html: row?.note ?? row?.message ?? "",
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="text-center py-5 bg-white rounded-12 border border-dashed text-muted fs-14 shadow-sm">
          <div className="opacity-50 mb-2">No activity logs or notes found for this document.</div>
        </div>
      )}
    </div>

  );
};

export default LogTable;
